import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

const About = () => {
	const { t } = useTranslation();
	return (
		<section className='container flex flex-col gap-6 md:items-center md:flex-row md:justify-evenly rounded-lg md:w-f relative top-[-50px] py-2'>
			<div className='image relative w-full mb-8'>
				<div className='image1 object-cover absolute top-[-20px] left-[-10px] w-24 h-24 md:w-32 md:h-32 md:top-[-40] md:left-[-20] z-50'>
					<img
						loading='lazy'
						className='object-cover w-full absolute rounded-lg'
						src={'/images/5.png'}
						alt='about us img'
					/>
				</div>
				<div className='image2 w-full top-0 left-0'>
					<img
						loading='lazy'
						className='object-cover w-full rounded-lg'
						src={'/images/6.png'}
						alt='about us img'
					/>
				</div>
			</div>

			<div className='flex flex-col items-start justify-center'>
				<div className='about w-full'>
					<p className='text-lg text-main font-meduim mb-4'>{t('aboutUs')}</p>
					<p className='text-3xl text-main font-semibold mb-4'>
						{t('strengthInNumbers')}
					</p>
					<p className='text-md text-textColor mb-6'>{t('aboutUsText')}</p>
				</div>
				<button className='py-2 px-5  rounded border-[1px] border-solid border-secondary md:hover:border-secondary md:hover:bg-secondary hover:text-white text-secondary transition-all duration-500'>
					<NavLink to='/'>{t('readMore')}</NavLink>
				</button>
			</div>
		</section>
	);
};

export default About;
